const machine_txt = {
    type: "VA-845D",
    name: "Single Direct Drive Double-needleLockstitch Sewing Machine",
    description: [
        "Applicable",
        "Common thin materials, medium-heavy and heavy material sewing for knitting wear, shirts, suites, leisure wear and jeans etc.",
        "Characteristics",
        "Synchronized fabric feeding of needle bar and feed dog to prevent fabric slip,fine adaptation to fabrics and nice in stitch. Fine adaptation to high quality double stitch and decorative sewing work.",
        "Adopt direct drive computerized servo-motor system, power saving up more than 40%.",
        "Automatic mini-oil lubricating with liquidometer in body. Easy to observe whether is oil or not.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/15/machine_img/1.jpg",
        "/assets/machine/15/machine_img/2.jpg",
    ],
    machine_other_img:[
        "/assets/machine/15/machine_other/1.png",
    ]
}
export default {machine_txt}